import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../components/footer/Footer';

const LayoutCliente = () => {
  return (
    <>
      <div className='container_interno'>
        <Outlet />
      </div>
      <Footer className='footer' />
    </>
  );
};

export default LayoutCliente;